module.exports = __webpack_public_path__ + "static/media/icon-forms.8549bf77.svg";